import { render } from "./OtherLayout.vue?vue&type=template&id=7cb76a46"
import script from "./OtherLayout.vue?vue&type=script&lang=js"
export * from "./OtherLayout.vue?vue&type=script&lang=js"

import "./OtherLayout.vue?vue&type=style&index=0&id=7cb76a46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__